module.exports = __webpack_public_path__ + "static/media/team-filled-icon.d0173d27.svg";